// extracted by mini-css-extract-plugin
export default {"tank":"tank_tank__RrKy5","wave":"tank_wave__8wHcs","animate":"tank_animate__Za3jm","animate2":"tank_animate2__cU5Qg"};